import { useEffect, useMemo } from 'react';
import Layout from 'components/layout';
import { useRecoilValue } from 'recoil';
import { getUser } from 'hooks/useUser';
import styles from '../style.module.scss';
import AdminView from '../adminView';
import useBreadcrumb from 'hooks/useBreadcrumb';

const DataExportPage = () => {
  const user = useRecoilValue(getUser);
  const { setBreadcrumb } = useBreadcrumb();

  const breadcrumb = useMemo(() => {
    if (user.isAdmin) {
      return [
        {
          title: 'Super admin',
          link: '#',
        },
        {
          title: 'Export dati',
          link: '/export-data',
        },
      ];
    }

    return [
      {
        title: user?.currentShop?.title,
        link: '#',
      },
      {
        title: 'Export dati',
        link: '/export-data  ',
      },
    ];
  }, [user]);

  useEffect(() => {
    setBreadcrumb(breadcrumb);
  }, [breadcrumb]);

  return (
    <Layout breadcrumb={breadcrumb}>
      <div className={styles.container}>
        <AdminView />
      </div>
    </Layout>
  );
};

export default DataExportPage;
